<!-- TEMPLATE CONTRACT: Ui Form Section Component owns the visible Angular template structure for src/app/shared/ui/ui-form-section/ui-form-section.component.html. -->
<ui-card>
  <section class="ui-form-section" [attr.data-variant]="variant()">
    <header class="ui-form-section__header">
      <div>
        <h2 class="ui-form-section__title">
          {{ title() | uiLabelTranslate }}
          <!-- Conditional branch documents the visible UI state for this condition. -->
          @if (required()) {
            <span class="ui-form-section__required">*</span>
          }
        </h2>
        <!-- Conditional branch documents the visible UI state for this condition. -->
        @if (description()) {
          <p class="ui-form-section__description">{{ description() | uiLabelTranslate }}</p>
        }
      </div>
    </header>

    <div class="ui-form-section__content">
      <ng-content />
    </div>
  </section>
</ui-card>
